// Date Formatter
// ==============

class DateFormatter {
    constructor(locale) {
        this.locale = locale;
        this.formatters = {
            d: (date) => date.getDate(),
            dd: (date) => {
                const day = date.getDate();
                return (day < 10) ? `0${day}` : day;
            },
            ddd: (date) => this.locale.daysShort[date.getDay()].toLowerCase(),
            DDD: (date) => this.locale.daysShort[date.getDay()],
            dddd: (date) => this.locale.days[date.getDay()].toLowerCase(),
            DDDD: (date) => this.locale.days[date.getDay()],
            M: (date) => date.getMonth() + 1,
            MM: (date) => {
                const month = date.getMonth() + 1;
                return (month < 10) ? `0${month}` : month;
            },
            mmm: (date) => this.locale.monthsShort[date.getMonth()].toLowerCase(),
            MMM: (date) => this.locale.monthsShort[date.getMonth()],
            mmmm: (date) => this.locale.months[date.getMonth()].toLowerCase(),
            MMMM: (date) => this.locale.months[date.getMonth()],
            yyyy: (date) => date.getFullYear(),
        };
    }

    format(date, format) {
        return format.replaceAll(/[a-z]*/gi, (match) => ((match in this.formatters) ? this.formatters[match](date) : match));
    }
}

export default DateFormatter;
